<template>
  <el-row class="server">
    <!-- <img src="../../assets/images/qq.jpg" alt title="在线客服"> -->
    <ul class="noprint">
      <li @click="ask">
        <i class="iconfont icon-kefu" style="font-size: 30px"></i>
        <span style="display: inline-block; margin-top: 5px">在线客服</span>
      </li>
      <li
        @click="toUrl('/work/work-list')"
        v-auth="'WODEGONGDAN_GONGDANLIEBIAO'"
      >
        <i class="iconfont icon-fankui" style="font-size: 30px"></i>
        <span style="display: inline-block; margin-top: 5px">投诉建议</span>
      </li>
      <li @click="toOther">
        <i class="iconfont icon-bangzhuzhongxin" style="font-size: 30px"></i>
        <span style="display: inline-block; margin-top: 5px">帮助中心</span>
      </li>
    </ul>
  </el-row>
</template>
<script>
import { isSuccess } from "@/assets/js/utils";
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    ask() {
      window.open(
        "https://cschat-ccs.aliyun.com/index.htm?tntInstId=_1LyzZ3o&scene=SCE00004694",
        "",
        "height=700, width=1000, top=200, left=200, toolbar=no, menubar=no,scrollbars=no, resizable=no,location=n o, status=no"
      );
    },
    toOther() {
      api("auth.login.info").then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          this.parent_dep_codes = data.parent_dep_codes;
          // 委托方
          if (this.parent_dep_codes.indexOf("PARTNERSHIP") !== -1) {
            window.open("http://doc.niuinfo.com/web/#/41");
          } else if (
            this.parent_dep_codes.indexOf("DELEGATE") !== -1 &&
            this.parent_dep_codes.indexOf("SHIPPER") !== -1
          ) {
            window.open("http://doc.niuinfo.com/web/#/41");
          } else if (
            this.parent_dep_codes.indexOf("SHIPPER") !== -1 ||
            this.parent_dep_codes.indexOf("FINANCE") !== -1
          ) {
            window.open("http://doc.niuinfo.com/web/#/39");
          } else if (this.parent_dep_codes.indexOf("DELEGATE") !== -1) {
            window.open("http://doc.niuinfo.com/web/#/40");
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.server {
  position: fixed;
  right: 25px;
  top: 18%;
  z-index: 1024;
  img {
    width: 80px;
  }
  ul {
    height: 150px;
    margin: 0 auto;
    li {
      list-style: none;
      height: 70px;
      width: 70px;
      background: #fff;
      border-bottom: 1px solid #dce4e6;
      padding-top: 10px;
      text-align: center;
      font-size: 12px;
      // color: #fff;
      position: relative;
      cursor: pointer;
    }
    li:hover {
      background: #ee424e;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer/customer-service.vue